import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { Router } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { ServerService } from '../../../../service/server/server.service';
import { ActivatedRoute } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountsDetaileComponent } from "../../bank-accounts/accounts-detaile/accounts-detaile.component";
import { MessageService } from '../../../../service/message/message.service';

@Component({
  selector: 'app-bank-accounts',
  templateUrl: './bank-accounts.component.html',
  styleUrls: ['./bank-accounts.component.scss']
})
export class BankAccountsComponent implements OnInit, OnDestroy {
  //**********************************************************
  public user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  public lang: any = JSON.parse(<any>localStorage.getItem('lang'));
  public loading: boolean = false;
  public count_total: number = 1;
  public list_record: any = [];
  public search_array: any = [];
  public code: any;
  public subscription: Subscription | any;
  public server!: string;
  public server_main!: string;
  public site!: string;
  public no_record!: string;
  public task_type!: number;
  public user_id!: number;
  public type_task!: number;
  public id!: number;
  public mat_table_selectedRow!: any;
  public mat_table_hoverRow!: any;
  public bank_id!: number;
  public creator!: number;
  public dataSource!: any;
  public displayedColumns = ['row', 'title', 'branch_title', 'cart_number', 'account_number', 'default', 'operation'];
  //************** */
  constructor(
    public serverService: ServerService,
    public ngxSmartModalService: NgxSmartModalService,
    public router: Router,
    public messageService: MessageService,
    public activatedRoute: ActivatedRoute,
    public matSnackBar: MatSnackBar, public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any,
    public matDialogRef: MatDialogRef<BankAccountsComponent>,
    public dialogRef: MatDialog) {
    this.server = this.serverService.get_server();
    this.server_main = this.serverService.get_server_main();
    this.site = this.serverService.get_site();
    this.no_record = this.serverService.no_record();
    if (dialog_data) {
      this.code = dialog_data.code;
      this.bank_id = dialog_data.id;
    }
  }
  ngOnInit() {
    this.serverService.status1(2);
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    this.check_access(4, 0, 1);
    //**************
  }//end ngOnInit

  //****************************************************************************
  check_access(type_task: number, id: any, loading: number): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return false;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (loading == 1) this.loading = true;
    var obj = {
      'address': 6,
      'type': 'user',
      'user_id': this.user_id,
      'id': this.code
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            this.message(true, this.messageService.access2(), 1, this.messageService.close());
          }
          else {
            this.creator = res['creator'];
            this.loading = false;
            if (type_task == 3) {
              this.delete(id);
            }
            if (type_task == 4) { this.load_data(); }
          }
        }//end if
        else {
          this.message(true, this.messageService.access(), 1, this.messageService.close());
        }
      }
    )
  }
  load_data(): any {
    var obj = {
      'address': 1941,
      'bank_id': this.bank_id,
      'user_id': this.user_id,
      'creator': this.creator
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_record.push(res['result'][i]);
          }//end for
          this.dataSource = new MatTableDataSource(this.list_record);
          this.count_total = res['count'];
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }//end else
      }//end res:Response
    ) //ens dubscribe
  }//end load data
  //***************************************************************************
  open_detaile(i: number, type_task: number, id: number) {
    const dialogRef = this.dialog.open(AccountsDetaileComponent, {
      width: '30rem',
      height: 'auto',
      disableClose: true,
      data: {
        'type_task': type_task,
        'id': id,
        'bank_id': this.bank_id,
        'i': i,
        'code': this.code,
      }
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {
          if (type_task == 1) {
            this.list_record.unshift(res.result);
            this.dataSource.data = this.list_record;
          }
          else if (type_task == 2) {
            this.list_record[i].site_bank_accounts_title = res.result.result.site_bank_accounts_title;
            this.list_record[i].site_bank_accounts_cart = res.result.result.site_bank_accounts_cart;
            this.list_record[i].site_bank_accounts_number = res.result.result.site_bank_accounts_number;
            this.list_record[i].site_bank_accounts_branch_title = res.result.result.site_bank_accounts_branch_title;
            this.list_record[i].site_bank_accounts_branch_code = res.result.result.site_bank_accounts_branch_code;
            this.list_record[i].site_bank_accounts_sheba = res.result.result.site_bank_accounts_sheba;
            this.list_record[i].site_bank_accounts_sort = res.result.result.site_bank_accounts_sort;
            this.list_record[i].status_title = res.result.result.status_title;
          }
          else if (type_task == 3) {
          }
        }
      }
    )
  }
  get_bg(id: number) {
    this.id = id;
  }
  //*******************************************************************************
  delete(id: number): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return false;
    }//end if
    else { this.matSnackBar.dismiss(); }
    var confirm_delete;
    confirm_delete = window.confirm(this.serverService.message_delete_accept());
    this.loading = false;
    if (confirm_delete == true) {
      this.loading = true;
      var obj = {
        'address': 1944,
        "user_id": this.user_id,
        'id': id,
      }
      this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
        (res: any) => {
          if (res['status'] == 1) {
            this.list_record.splice(this.list_record.findIndex((index: any) => index.site_bank_accounts_id == id), 1);
            this.dataSource.data = this.list_record;
            this.message(true, this.messageService.delete2(), 1, this.messageService.close());
          }//end if
          else if (res['status'] == 4) {
            this.message(true, this.messageService.message_delete_alarm(), 1, this.messageService.close());
          }
          else {
            this.message(true, this.messageService.message_error(), 1, this.serverService.message_action());
          }//end else
        }//end res:Response
      )//end this.subscription
    }//end this.confirm_delete == true    
  }//end delete
  change_default(j: number, value: number, id: number): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return false;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 1966, user_id: this.user_id, 'status_default': value, 'id': id, creator: this.creator }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (value == 0) {
            for (var i = 0; i < this.list_record.length; i++) {
              if (this.list_record[i].site_bank_accounts_default == 1) {
                this.list_record[i].site_bank_accounts_default = 0;
              }
            }
          }
          this.list_record[j].site_bank_accounts_default = res['result'][0].site_bank_accounts_default;
          this.dataSource = new MatTableDataSource(this.list_record);
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else if (res['status'] == 4) {
          this.message(true, this.messageService.erorr_in_save_default(this.lang), 1, this.messageService.close());
        }
        else {
          this.message(true, this.messageService.erorr_in_save(), 1, this.messageService.close());
        }
      }
    );
  }
  close() {
    this.matDialogRef.close();
  }
  //*******************************************************************************
  change_resize() {
    //this.serverService.change_window_resize(1,'',0);
  }//end change_resize
  //*******************************************************************************
  message(validation: boolean, message: string, type: number, action: string) {
    if (type == 1) this.loading = false;
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 4000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end 
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}
